import { render, staticRenderFns } from "./CreateVirtualBank.vue?vue&type=template&id=dedd1c08&scoped=true"
import script from "./CreateVirtualBank.vue?vue&type=script&lang=js"
export * from "./CreateVirtualBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedd1c08",
  null
  
)

export default component.exports